import { DrawerBody, Flex, Stack } from '@chakra-ui/react';
import { ContractModalFooter } from '../../../molecules';
import { useChangePlanModalContext } from '../ModalContext';
import PlansDetails from './PlansDetails';

interface ChangePlanModalConfirmationProps {
  onClose(): void;
}

const Confirmation: React.FC<ChangePlanModalConfirmationProps> = ({
  onClose,
}) => {
  const { handleSubmit, selectedPlan } = useChangePlanModalContext();

  return (
    <Flex direction="column" h="100%" justify="space-between" px={4}>
      <DrawerBody scrollBehavior="auto">
        <Stack py="1rem" minH="100%">
          <PlansDetails />
        </Stack>
      </DrawerBody>
      <ContractModalFooter
        onCancel={onClose}
        onNext={handleSubmit}
        nextLabel={'Trocar'}
        isNextDisabled={!selectedPlan}
      />
    </Flex>
  );
};

export default Confirmation;
